import React, { useState } from 'react';
import SvgexpIcon1 from './../../../assets/svgIcons/SvgexpIcon1';
import SvgexpIcon2 from './../../../assets/svgIcons/SvgexpIcon2';
import SvgexpIcon3 from './../../../assets/svgIcons/SvgexpIcon3';
import SvgexpIcon4 from './../../../assets/svgIcons/SvgexpIcon4';
import { Row, Col } from 'react-bootstrap';
import './../../../translations/i18n';
import { useTranslation } from 'react-i18next';

const HomeExperiance = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className="expamnt">
                <Row className="g-2 text-center" xs={2} md={4}>
                    <Col><div><SvgexpIcon4/></div><p>20<samp>+</samp></p><span>{t('Years of Experience')}</span></Col>
                    <Col><div><SvgexpIcon2/></div><p>10,000<samp>+</samp></p><span>{t('Completed Projects')}</span></Col>
                    <Col><div><SvgexpIcon3/></div><p>1,000<samp>+</samp></p><span>{t('Active Clients')}</span></Col>
                    <Col><div><SvgexpIcon1/></div><p>50<samp>+</samp></p><span>{t('Skilled Staff')}</span></Col>
                </Row>
            </div>
        </>
    );
}

export default HomeExperiance;